<template>
	<div class="login-vue">
		<div class="center-div">
			<div class="left-part">
				<img src="../assets/imgs/logo.jpg" width="300px" height="300px" style="margin-top: 30px;" />
			</div>
			<div class="right-part">
				<div class="login-content-div">
					<div v-if="type==0" class="login-container">
						<p class="title">WELCOME</p>
						<div class="input-c">
							<Input prefix="ios-contact" v-model="account" placeholder="用户名" clearable
								@on-blur="verifyAccount" />
							<p class="error">{{accountError}}</p>
						</div>
						<div class="input-c">
							<Input type="password" v-model="pwd" prefix="md-lock" placeholder="密码" clearable
								@on-blur="verifyPwd" @keyup.enter.native="submit" />
							<p class="error">{{pwdError}}</p>
						</div>
						<Button :loading="isShowLoading" class="submit" type="primary" @click="submit">登陆</Button>
						<p class="account">
							<span @click="register(1)">注册账号</span>
							| <span @click="register(2)">忘记密码</span>
						</p>
					</div>
					<div v-else-if="type==1" class="forget-container">
						<p class="title">注册</p>
						<p style="text-align:left;cursor:pointer;">
							<Icon type="ios-undo" size='28' />
							<span style="font-size:16px;" @click="register(0)" class="document-click">去登陆</span>
						</p>
						<Form ref="formRegister" :model="registerModel" :label-width="10" :rules="ruleRegister">
							<Form-item prop="code">
								<Input prefix="ios-call" v-model="registerModel.code" placeholder="请输入手机号" />
							</Form-item>
							<Form-item prop="loginPwd">
								<Input prefix="md-lock" v-model="registerModel.loginPwd" type="password"
									placeholder="请输入登录密码" />
							</Form-item>
							<Form-item prop="checkCode">
								<CheckCodeBox :telephone="registerModel.code" @result='checkCodeChangeRegister'>
								</CheckCodeBox>
							</Form-item>

							<Form-item>
								<Button :loading="isShowLoading" style="width:100%;" class="submit" type="primary"
									@click="registerSubmit">注册</Button>
							</Form-item>
						</Form>
					</div>
					<div v-else class="forget-container">
						<p class="title">重置密码</p>
						<p style="text-align:left;cursor:pointer;">
							<Icon type="ios-undo" size='28' />
							<span style="font-size:16px;" @click="register(0)" class="document-click">去登陆</span>
						</p>
						<Form ref="formForget" :model="forgetModel" :label-width="10" :rules="ruleForget">
							<Form-item prop="code">
								<Input prefix="ios-call" v-model="forgetModel.code" placeholder="请输入手机号" />
							</Form-item>
							<Form-item prop="loginPwd">
								<Input prefix="md-lock" v-model="forgetModel.loginPwd" type="password"
									placeholder="请输入新密码" />
							</Form-item>
							<Form-item prop="checkCode">
								<CheckCodeBox :telephone="forgetModel.code" @result='checkCodeChangeForget'>
								</CheckCodeBox>
							</Form-item>
							<Form-item>
								<Button :loading="isShowLoading" style="width:100%;" class="submit" type="primary"
									@click="forgetSubmit">提交</Button>
							</Form-item>
						</Form>
					</div>
					<div class="user-agree">
						<input type="checkbox" v-model="isAgree" />
						<span>登陆或注册即同意<span class="document-click" @click="agreementClick('用户协议')">《用户协议》</span>和<span
								class="document-click" @click="agreementClick('隐私协议')">《隐私协议》</span></span>
					</div>
					<Modal v-model="isShowAgreement" draggable sticky scrollable :width="1000">
						<p slot="header" class="modal-header">
							<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
							<span>{{agreementData.title.content}}</span>
						</p>
						<div style="width:100%;background-color:#fff;border-radius:5px;height:500px;overflow:auto;">
							<div style="padding: 15px;">
								<div v-for="(item,index) in agreementData.items" :key="index" class="agreement_item"
									:style="item.style">
									{{item.content}}
								</div>
							</div>
						</div>
						<div slot="footer">
							<Button size="large" @click="isShowAgreement=false">确定</Button>
						</div>
					</Modal>
				</div>
			</div>
		</div>
		<div class="login-foot">
			— <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024093359号</a>｜京公网安备11011202100905号 —
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import CheckCodeBox from '@/components/CheckCodeBox'
	export default {
		name: 'login',
		components: {
			CheckCodeBox
		},
		data() {
			return {
				account: '',
				pwd: '',
				accountError: '',
				pwdError: '',
				isShowLoading: false,
				type: 0, //0:登录；1：注册
				registerModel: {
					code: '',
					name: '',
					supervisor: '',
					contactNumber: '',
					email: '',
					address: '',
					creator: 0,
					createDate: '',
					note: '',
					loginCode: '',
					loginPwd: ''
				},
				checkCodeRegister: '',
				randomCodeRegister: '',
				ruleRegister: {
					code: [{
							required: true,
							message: '请填写手机号码',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于11个位',
							trigger: 'blur'
						}
					],
					loginPwd: [{
							required: true,
							validator: this.logPwdVerify,
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '密码不得大于20位',
							trigger: 'blur'
						}
					],
					checkCode: [{
						required: true,
						validator: this.checkCodeVerifyRegister,
						trigger: 'blur'
					}]
				},
				isAgree: false,
				isShowAgreement: false,
				agreementData: {
					pageTitle: '',
					title: '',
					items: [],
				},
				forgetModel: {
					code: '',
					name: '',
					supervisor: '',
					contactNumber: '',
					email: '',
					address: '',
					creator: 0,
					createDate: '',
					note: '',
					loginCode: '',
					loginPwd: ''
				},
				checkCodeForget: '',
				randomCodeForget: '',
				ruleForget: {
					code: [{
							required: true,
							message: '请填写手机号码',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于11个位',
							trigger: 'blur'
						}
					],
					loginPwd: [{
							required: true,
							validator: this.logPwdVerify,
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '密码不得大于20位',
							trigger: 'blur'
						}
					],
					checkCode: [{
						required: true,
						validator: this.checkCodeVerifyForget,
						trigger: 'blur'
					}]
				}
			}
		},
		created() {},
		watch: {
			$route: {
				handler(route) {
					if (route.query.type && route.query.type == 'register') {
						this.type = 1;
					} else {
						this.type = 0;
					}
					this.redirect = route.query && route.query.redirect
				},
				immediate: true,
			},
		},
		methods: {
			verifyAccount() {
				if (!this.account) {
					this.accountError = '请输入账号'
				} else {
					this.accountError = ''
				}
			},
			verifyPwd() {
				if (!this.pwd) {
					this.pwdError = '请输入密码'
				} else {
					this.pwdError = ''
				}
			},
			register(type) {
				this.type = type;
			},
			submit() {
				let component = this;
				if (component.account && component.pwd) {
					if (!this.isAgree) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '请先同意协议'
						});
						return;
					}
					component.isShowLoading = true;
					let data = {
						'LoginCode': component.account,
						'Pwd': component.pwd
					}
					localStorage.setItem('token',
						'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiSW52ZW50b3J5Q2xvdWQiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJJbnZlbnRvcnlDbG91ZCIsImV4cCI6MTc4ODAxNTE1MCwiaXNzIjoid2ViYWRtaW4iLCJhdWQiOiJ1c2VyIn0.eGJ2aKZCMqwwiShb7mD53PfmZTiSBUzS4ze-h4SDS_k'
					);
					component.$axios.post('/api/Company/Login', data, {
						headers: {
							authorization: localStorage.getItem('token')
						},
					}).then(function(response) {
						// 登陆成功 设置用户信息
						if (response.data.state != 1) {
							component.isShowLoading = false;
							component.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: response.data.errorMsg
							});
							return;
						} else if (!response.data.data) {
							component.pwdError = "登录失败：请验证账号密码";
							component.isShowLoading = false;
							return;
						}
						localStorage.setItem('schema', response.data.data.schema);
						localStorage.setItem('workshop', response.data.data.workShop);
						localStorage.setItem('userImg', response.data.data.headImg == "" ?
							'https://avatars3.githubusercontent.com/u/22117876?s=460&v=4' : response.data
							.data.headImg)
						localStorage.setItem('userName', response.data.data.userDisplayName);
						localStorage.setItem("userId", response.data.data.id);
						component.$router.push({
							path: component.redirect || '/'
						});

					}).catch(function(error) {
						component.pwdError = "登录失败：系统出现故障";
						component.isShowLoading = false;
						return;
					})

				} else {
					if (!this.account) {
						this.accountError = '请输入账号'
					}

					if (!this.pwd) {
						this.pwdError = '请输入密码'
					}
				}
			},
			agreementClick(tag) {
				this.isShowAgreement = true;
				if (tag == '用户协议') {
					this.agreementData = {
						pageTitle: '用户协议',
						title: {
							content: '《进销云端软件用户协议》',
							style: "font-weight:700"
						},
						items: [{
								content: '本协议是您与进销云端提供商北京果熊科技有限公司（以下简称“本软件”）之间的协议，本协议规定了您使用本软件的条款和条件。请在使用本软件之前仔细阅读本协议，如果您不同意本协议，请不要使用本软件。',
								style: ""
							},
							{
								content: '1.软件许可',
								style: "font-weight:700"
							},
							{
								content: '本软件是一款免费的进销存管理软件，您可以在不违反本协议的情况下自由使用。本软件的版权归北京果熊科技有限公司所有，未经授权，您不得复制、修改、传播、出售或以其它方式使用本软件。',
								style: ""
							},
							{
								content: '2.用户责任',
								style: "font-weight:700"
							},
							{
								content: '您在使用本软件时，需遵守以下规定：',
								style: ""
							},
							{
								content: '（1）不得使用本软件进行非法活动；',
								style: ""
							},
							{
								content: '（2）不得利用本软件进行侵犯他人知识产权的行为；',
								style: ""
							},
							{
								content: '（3）不得利用本软件进行垃圾邮件或其它骚扰行为；',
								style: ""
							},
							{
								content: '（4）不得利用本软件进行攻击或破坏行为。',
								style: ""
							},
							{
								content: '3.免责声明',
								style: "font-weight:700"
							},
							{
								content: '本软件不保证软件运行的稳定性和可靠性，也不对因使用本软件而产生的任何直接或间接损失负责。本软件不对因不可抗力、黑客攻击、计算机病毒等原因导致的数据丢失、泄露等问题负责。',
								style: ""
							},
							{
								content: '4.隐私保护',
								style: "font-weight:700"
							},
							{
								content: '本软件将严格保护用户的个人隐私，不会泄露用户的个人信息。但在法律规定的情况下，本软件可能会根据法律要求提供用户的个人信息。',
								style: ""
							},
							{
								content: '5.协议修改',
								style: "font-weight:700"
							},
							{
								content: '本软件有权根据需要修改本协议，修改后的协议将在本软件登录前消息提醒。如果您在修改后继续使用本软件，即视为您已接受修改后的协议。',
								style: ""
							},
							{
								content: '6.法律适用',
								style: "font-weight:700"
							},
							{
								content: '本协议适用中华人民共和国法律。如果因本协议引起任何纠纷，双方应协商解决；协商不成的，任何一方均可向本软件所在地的人民法院提起诉讼。',
								style: ""
							},
							{
								content: '7.用户权利',
								style: "font-weight:700"
							},
							{
								content: '用户有权在遵守本协议的前提下，自由使用本软件提供的功能和服务。',
								style: ""
							},
							{
								content: '8.服务内容',
								style: "font-weight:700"
							},
							{
								content: '本软件提供的服务内容包括但不限于进销存管理、报表生成、数据备份等功能。用户在使用本软件时应当遵守相关法律法规，不得利用本软件从事违法违规行为。',
								style: ""
							},
							{
								content: '9.安全保障',
								style: "font-weight:700"
							},
							{
								content: '为保障用户数据的安全，本软件将采取合理的安全措施，包括但不限于数据加密、访问权限控制等措施。用户也应当妥善保管自己的账号和密码，不得将账号和密码泄露给他人。',
								style: ""
							},
							{
								content: '10.服务变更和终止',
								style: "font-weight:700"
							},
							{
								content: '本软件有权根据业务发展的需要，变更或终止部分或全部服务内容，变更或终止服务时，将提前通知用户，并尽力保障用户的利益。',
								style: ""
							},
							{
								content: '11.知识产权',
								style: "font-weight:700"
							},
							{
								content: '本软件的一切知识产权，包括但不限于软件著作权、商标权、专利权等，均归北京果熊科技有限公司所有。未经授权，用户不得擅自使用、复制、传播本软件的相关知识产权。',
								style: ""
							},
							{
								content: '12.其它条款',
								style: "font-weight:700"
							},
							{
								content: '本协议的解释、效力、变更、执行和争议解决等，均适用中华人民共和国法律。如本协议的任何条款无效或不可执行，不影响其它条款的效力。',
								style: ""
							},
							{
								content: '用户在使用本软件的过程中，应当遵守本协议的规定，如违反本协议，本软件有权停止对用户提供服务，并保留追究用户法律责任的权利。',
								style: ""
							},
							{
								content: '本协议自用户开始使用本软件时生效，直至用户停止使用本软件。',
								style: ""
							}
						]
					}
				} else {
					this.agreementData = {
						pageTitle: '隐私协议',
						title: {
							content: '《进销云端软件隐私协议》',
							style: "font-weight:700"
						},
						items: [{
								content: '1.引言',
								style: "font-weight:700"
							},
							{
								content: '欢迎使用进销云端进销存软件（以下简称“本软件”）。我们尊重您的隐私并承诺保护您的个人信息。本隐私协议（以下简称“本协议”）旨在向您清晰地说明我们对您个人信息的收集、使用和保护方式。在使用本软件之前，请仔细阅读并理解本协议，它将成为您与我们之间的法律协议的一部分。',
								style: {}
							},
							{
								content: '2.信息收集',
								style: "font-weight:700"
							},
							{
								content: '当我们提供服务时，我们可能会收集以下信息：',
								style: {}
							},
							{
								content: '个人信息',
								style: "font-weight:700"
							},
							{
								content: '（1）基本信息：包括但不限于您的姓名、联系方式、电子邮箱地址等；',
								style: {}
							},
							{
								content: '（2）账户信息：如果您注册账户，我们可能会收集您的用户名、密码等信息；',
								style: {}
							},
							{
								content: '使用信息',
								style: "font-weight:700"
							},
							{
								content: '（1）软件使用情况：我们可能会收集您使用软件功能的情况，包括您访问的页面、点击的链接等；',
								style: {}
							},
							{
								content: '（2）系统日志：我们可能会收集与您的使用行为相关的系统日志信息，例如您的IP地址、浏览器类型、操作系统等；',
								style: {}
							},
							{
								content: '定位信息',
								style: "font-weight:700"
							},
							{
								content: '（1）地理位置：我们可能会收集您的设备位置信息，以提供个性化服务或改进服务质量；',
								style: {}
							},
							{
								content: '通讯信息',
								style: "font-weight:700"
							},
							{
								content: '（1）评论和反馈：我们可能会收集您通过评论、反馈、调查问卷等方式提供的信息；',
								style: {}
							},
							{
								content: '技术信息',
								style: "font-weight:700"
							},
							{
								content: '（1）Cookies和Web Beacons：我们可能会使用cookies、web beacons或其它跟踪技术来帮助我们收集和分析信息；',
								style: {}
							},
							{
								content: '3.信息使用',
								style: "font-weight:700"
							},
							{
								content: '我们收集的信息将主要用于以下目的：',
								style: {}
							},
							{
								content: '为您提供服务',
								style: "font-weight:700"
							},
							{
								content: '（1）我们将使用您的个人信息来提供和改进我们的软件服务；',
								style: {}
							},
							{
								content: '联系和沟通',
								style: "font-weight:700"
							},
							{
								content: '（1）我们可能会联系您以回应您的查询或请求',
								style: {}
							},
							{
								content: '发送更新和通知',
								style: "font-weight:700"
							},
							{
								content: '（1）我们将使用您的联系方式来发送软件更新和重要通知；',
								style: {}
							},
							{
								content: '产品和服务分析',
								style: "font-weight:700"
							},
							{
								content: '（1）我们可能会分析使用数据来改进我们的产品和服务；',
								style: {}
							},
							{
								content: '法律义务',
								style: "font-weight:700"
							},
							{
								content: '（1）我们可能会将您的信息分享给第三方服务提供商，以执行法律义务或在紧急情况下保护我们的合法权益；',
								style: {}
							},
							{
								content: '4.信息安全',
								style: "font-weight:700"
							},
							{
								content: '我们采取适当的技术和组织措施来保护您的个人信息免受未经授权的访问、使用或披露。我们遵守适用的数据保护法律和行业标准，确保您的个人信息的安全。',
								style: {}
							},
							{
								content: '5.您的权利',
								style: "font-weight:700"
							},
							{
								content: '作为用户，您拥有以下权利：',
								style: {}
							},
							{
								content: '（1）访问权：您有权访问我们持有的您的个人信息；',
								style: {}
							},
							{
								content: '（2）更正权：您有权更正任何不准确或不完整的个人信息；',
								style: {}
							},
							{
								content: '（3）删除权：在特定情况下，您有权要求我们删除您的个人信息；',
								style: {}
							},
							{
								content: '（4）数据携带权：您有权要求我们提供您的个人信息的副本；',
								style: {}
							},
							{
								content: '（5）反对权：您有权反对我们基于自动化处理的目的使用您的个人信息',
								style: {}
							},
							{
								content: '6.更新和更改',
								style: "font-weight:700"
							},
							{
								content: '我们保留在不通知您的情况下更新本协议的权利。更新后的协议将适用于您继续使用本软件的行为。我们建议您定期查看本协议，以确保您了解当前的条款和条件。',
								style: {}
							},
							{
								content: '7.适用法律',
								style: "font-weight:700"
							},
							{
								content: '本协议受您使用我们软件所在地的法律管辖，并按照该地的法律解释。',
								style: {}
							},
							{
								content: '8.效力',
								style: "font-weight:700"
							},
							{
								content: '本协议自您首次使用本软件之日起生效。',
								style: {}
							}
						]
					}
				}
			},
			registerSubmit() {
				this.$refs["formRegister"].validate((valid) => {
					if (valid) {
						if (!this.isAgree) {
							this.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '请先同意协议'
							});
							return;
						}
						this.isShowLoading = true;
						let self = this;
						self.registerModel.name = self.registerModel.code
						self.registerModel.contactNumber = self.registerModel.code
						self.registerModel.loginCode = self.registerModel.code
						this.$axios.post('/api/Company/RegisterCompany', self.registerModel).then(function(
							response) {
							if (response.data.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '注册失败:' + response.data.errorMsg
								});
								self.isShowLoading = false;
								return;
							}
							self.$refs['formRegister'].resetFields();
							self.type = 0;
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '注册成功!'
							});
							self.isShowLoading = false;
						}).catch(function(error) {})
					}
				})
			},
			checkCodeChangeRegister(data) {
				this.checkCodeRegister = data.value;
				this.randomCodeRegiser = data.randomCode;
			},
			checkCodeVerifyRegister(rule, value, callback) {
				if (!this.checkCodeRegister) {
					callback(new Error('请填写验证码'));
				} else if (this.checkCodeRegister != this.randomCodeRegister) {
					callback(new Error('验证码错误'));
				} else {
					callback();
				}
			},
			logPwdVerify(rule, value, callback) {
				if (!value) {
					callback(new Error('请填写密码'));
				} else if (!/^(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(value)) {
					callback(new Error('须包含数字、字母和特殊字符并且大于8位'));
				} else {
					callback();
				}
			},
			checkCodeChangeForget(data) {
				this.checkCodeForget = data.value;
				this.randomCodeForget = data.randomCode;
			},
			checkCodeVerifyForget(rule, value, callback) {
				if (!this.checkCodeForget) {
					callback(new Error('请填写验证码'));
				} else if (this.checkCodeForget != this.randomCodeForget) {
					callback(new Error('验证码错误'));
				} else {
					callback();
				}
			},
			forgetSubmit() {
				this.$refs["formForget"].validate((valid) => {
					if (valid) {
						this.isShowLoading = true;
						let self = this;
						this.$axios.post('/api/Company/ChangePwd', {
							code: self.forgetModel.code,
							loginPwd: self.forgetModel.loginPwd
						}).then(function(
							response) {
							if (response.data.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '注册失败:' + response.data.errorMsg
								});
								self.isShowLoading = false;
								return;
							}

							self.$refs['formForget'].resetFields();
							self.type = 0;
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '重置成功!'
							});
							self.isShowLoading = false;
						}).catch(function(error) {})
					}
				})
			}
		}
	}
</script>

<style>
	.login-vue {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		/* 设置相对定位，以便内部绝对定位的伪元素能正确地相对于此容器进行定位 */
		width: 100%;
		overflow: hidden;
		/* 防止图片超出容器范围 */
		z-index: 0;
		/* 确保容器下的伪元素不会覆盖其它内容 */
	}

	.login-vue::before,
	.login-vue::after {
		content: "";
		/* 必须有内容，哪怕是一个空字符串，因为伪元素基于内容生成 */
		position: absolute;
		/* 使用绝对定位 */
		width: 50%;
		/* 图片宽度占据容器一半 */
		height: 100%;
		/* 图片高度与容器高度相同 */
		z-index: -1;
		/* 让伪元素位于容器下方，防止遮挡容器内其它内容 */
	}

	.login-vue::before {
		background-image: url('../assets/imgs/bg-login-left.png');
		background-size: cover;
		/* 背景图片填充整个伪元素区域，保持其宽高比 */
		background-position: center;
		/* 图片居中显示（可以根据需求调整） */
		left: 0;
		/* 将伪元素定位到容器左侧 */
		top: 0;
		/* 定位到容器顶部 */
	}

	.login-vue::after {
		background-image: url('../assets/imgs/bg-login-right.png');
		background-size: cover;
		background-position: center;
		right: 0;
		/* 将伪元素定位到容器右侧 */
		top: 0;
		/* 定位到容器顶部 */
	}

	.login-container {
		text-align: center;
		color: #00aebc;
	}

	.login-container .submit {
		margin-top: 25px;
	}

	.login-vue .ivu-input {
		background-color: transparent;
		border-color: #dee1e6;
		border-top: none;
		border-left: none;
		border-right: none;
	}

	.login-vue ::-webkit-input-placeholder {
		/* WebKit, Blink, Edge */
		color: rgba(255, 255, 255, .8);
	}

	.login-vue :-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: rgba(255, 255, 255, .8);
	}

	.login-vue ::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: rgba(255, 255, 255, .8);
	}

	.login-vue :-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: rgba(255, 255, 255, .8);
	}

	.title {
		font-size: 24px;
		margin-bottom: 20px;
	}

	.login-vue .input-c {
		margin: auto;
		width: 300px;
	}

	.login-vue .error {
		color: red;
		text-align: left;
		margin: 5px auto;
		font-size: 12px;
		padding-left: 30px;
		height: 20px;
	}

	.login-vue .submit {
		width: 200px;
	}

	.login-vue .account {
		margin-top: 30px;
	}

	.login-vue .account span {
		cursor: pointer;
		color: #00aebc;
	}

	.login-vue .ivu-icon {}

	.login-vue .ivu-icon-ios-close-circle {
		color: #777;
	}

	.user-agree {
		text-align: center;
		margin-top: 15px;
	}

	.document-click {
		cursor: pointer;
	}

	.document-click:hover {
		color: rgb(255, 77, 77);
	}

	.agreement_item {
		margin-bottom: 15px;
	}

	.center-div {
		width: 740px;
		height: 420px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(-50%);
	}

	.left-part {
		height: inherit;
		width: 300px;
		background: url('../assets/imgs/leftpart.png');
		float: left;
		border-radius: 3px 0px 0px 3px;
	}

	.right-part {
		float: right;
		width: calc(100% - 300px);
	}

	.login-content-div {
		width: 440px;
		height: 480px;
		background-color: #fff;
		position: relative;
		top: -31px;
		padding: 40px 0 8px;
		box-sizing: border-box;
		border-radius: 3px;
	}

	.forget-container {
		margin: 0px auto;
		width: 300px;
	}

	.forget-container .title {
		text-align: right;
		color: #00aebc;
	}

	.login-foot {
		width: 100%;
		text-align: center;
		position: absolute;
		bottom: 10px;
		left: 0;
		/* 或者 right: 0; 根据需要将元素定位到左边或右边 */
		color: grey;
	}

	.modal-header {
		display: flex !important;
		justify-content: left;
		align-items: center;
	}
</style>